import { Button } from '@flexo/atoms';
import { IconWrapper } from '@flexo/general';
import { getOrgRole, isEndUser } from '@flexo/hooks';
import { USER } from '@flexo/reducers';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from './access-denied.module.scss';

const ENV = (import.meta as any).env;

export function AccessDenied() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);
  const [isPasswordReset, setIsPasswordReset] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('enduserPasswordResetSuccess') === 'true') {
      sessionStorage.removeItem('enduserPasswordResetSuccess');
      setIsPasswordReset(true);
    }
  }, []);

  const title = isPasswordReset
    ? t('pages.enduser_reset_success.title')
    : t('alerts.enduser_not_allowed.title');

  const description = isPasswordReset
    ? t('pages.enduser_reset_success.description')
    : t('alerts.enduser_not_allowed.description');

  const goHome = () => {
    const role = getOrgRole(user);
    const endUserId = user?.metadata?.flexo_user_id;
    const homePath =
      isEndUser(role) && endUserId
        ? `/member/${endUserId}`
        : `/${ENV.VITE_APP_FIRST_PAGE}`;

    navigate(homePath, { replace: true });
  };

  const logOut = () => {
    dispatch(USER.ShowSplashScreen());
    dispatch(USER.SetIsLoggingOut());
    dispatch(USER.SetLogout());
  };

  return (
    <div className={styles.AccessDenied}>
      <div className={styles.AccessDenied__Shell}>
        <div className={styles.AccessDenied__Card}>
          <div className={styles.AccessDenied__Logo}>
            <IconWrapper iconName="logo_wide" />
          </div>
          <div className={styles.AccessDenied__Content}>
            <div className={styles.AccessDenied__Header}>
              <div className={styles.AccessDenied__Header__Title}>{title}</div>
            </div>
            <div className={styles.AccessDenied__Description}>
              <p>{description}</p>
            </div>
          </div>
          {!isPasswordReset && (
            <div className={styles.AccessDenied__Actions}>
              <Button
                className={styles.AccessDenied__HomeButton}
                label={t('alerts.enduser_not_allowed.logout')}
                variant="secondary"
                color="grey"
                onClick={logOut}
              />
              <Button
                className={styles.AccessDenied__HomeButton}
                label={t('alerts.enduser_not_allowed.go_home')}
                variant="primary"
                color="secondary"
                onClick={goHome}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AccessDenied;
